import { supabase } from "@/lib/supabase";

export function cleaningIssueErrorMessagePl(err: unknown): string {
  const raw =
    err && typeof err === "object" && "message" in err
      ? String((err as { message: unknown }).message)
      : err instanceof Error
        ? err.message
        : "";
  if (raw.includes("ISSUE_AUTH_REQUIRED")) return "Musisz być zalogowany.";
  if (raw.includes("ISSUE_NOT_FOUND")) return "Nie znaleziono zgłoszenia lub brak uprawnień.";
  if (raw.includes("ISSUE_CLEANING_RELEASE_FORBIDDEN")) {
    return "Nie można przekazać tej usterki poza moduł sprzątania.";
  }
  if (raw.includes("ISSUE_CLEANING_RESOLVE_FORBIDDEN")) {
    return "Nie można zmienić statusu — zgłoszenie zostało już przekazane dalej lub nie pochodzi z kolejki sprzątania.";
  }
  return raw.trim() || "Nie udało się zaktualizować usterki.";
}

export async function releaseCleaningPropertyIssue(issueId: string): Promise<void> {
  const { error } = await supabase.rpc("release_cleaning_property_issue", {
    p_issue_id: issueId,
  });
  if (error) {
    console.error("[releaseCleaningPropertyIssue]", error);
    throw new Error(cleaningIssueErrorMessagePl(error));
  }
}

export async function resolveCleaningReleasedPropertyIssue(issueId: string): Promise<void> {
  const { error } = await supabase.rpc("resolve_cleaning_released_property_issue", {
    p_issue_id: issueId,
  });
  if (error) {
    console.error("[resolveCleaningReleasedPropertyIssue]", error);
    throw new Error(cleaningIssueErrorMessagePl(error));
  }
}

export async function insertCleaningPropertyIssue(input: {
  description: string;
  locationId: string;
  orgId: string;
  reporterId: string;
  photoUrl: string | null;
  autoNotify: boolean;
}): Promise<string> {
  const { data, error } = await supabase
    .from("property_issues")
    .insert({
      description: input.description,
      location_id: input.locationId,
      org_id: input.orgId,
      reporter_id: input.reporterId,
      reporter_type: "cleaner",
      source: "cleaning",
      status: "pending_cleaning_review",
      photo_url: input.photoUrl,
      notification_status: "pending",
    })
    .select("id")
    .single();

  if (error) {
    console.error("[insertCleaningPropertyIssue]", error);
    throw error;
  }
  if (!data?.id) {
    throw new Error("Nie udało się zapisać zgłoszenia.");
  }

  if (input.autoNotify) {
    await releaseCleaningPropertyIssue(data.id);
  }

  return data.id;
}
